import '../App.css';
import Heading from '../components/heading';
import Navigation from '../components/navigation';
import Footer from '../components/footer';



function mc() {
  return (
    <div className="wrapper">
      <Heading />
      <Navigation />
      <div id="content">

      <p><span class="style3">The NTBA</span> is a not-for-profit association that supports and promotes bridge in the Northern Territory on behalf of its members - the three affiliated NT bridge clubs.</p>

<p align="justify">The affiliated clubs direct the association through their membership of Council, which generally meets twice yearly. Day-to-day affairs are dealt with by a Management Committee.</p>

<p align="justify">The Association's policy is not to compete with its member clubs  - rather it supports beginner and other lessons. </p>

<p align="justify">Through its Tournament Committee, it organises Championship-level competitions open to all NT playing members (and visitors). It also convenes the annual Territory Gold Bridge Festival, held alternately in Darwin and Alice Springs.</p>


<table width="77%" border="0" align="left" bgcolor="#FFFF99">

  <tr>

    <td width="27%"><b>Management Commmittee:</b></td>

    <td width="50%"><b>Pam Nunn   (President)</b></td>

    <td width="23%"><b>0402 852 820 </b></td>

    </tr>


  <tr>

    <td>&nbsp;</td>

    <td><b>Sal Costanzo   (Treasurer)</b></td>

    <td>&nbsp;</td>

    <td>&nbsp;</td>

  </tr>

  <tr>

    <td>&nbsp;</td>

    <td><b>Marion Davey</b> non voting member</td>

    <td>&nbsp;</td>

    <td>&nbsp;</td>

  </tr>

  <tr>

    <td>&nbsp;</td>

    <td><b>Teodora Yanova</b> voting member</td>

    <td>&nbsp;</td>

    <td>&nbsp;</td>

  </tr>

</table>

<p>&nbsp;</p>

      </div>


      
      <Footer/>
    </div>
  );
}

export default mc;